'use client';
import { useState } from 'react';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { useServerInsertedHTML } from 'next/navigation';

export function EmotionCacheProvider({ children }) {
  const [cache] = useState(() => {
    const cache = createCache({ key: 'css' });
    cache.compat = true;
    return cache;
  });

  useServerInsertedHTML(() => {
    const entries = Object.entries(cache.inserted);
    if (entries.length === 0) return null;

    const styles = entries
      .filter(([, value]) => typeof value === 'string')
      .map(([name, value]) => ({ name, value }));

    if (styles.length === 0) return null;

    return (
      <style
        data-emotion={`${cache.key} ${styles.map(s => s.name).join(' ')}`}
        dangerouslySetInnerHTML={{ __html: styles.map(s => s.value).join('') }}
      />
    );
  });

  return <CacheProvider value={cache}>{children}</CacheProvider>;
}
